import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=19e616a4&"
import script from "./Colaboradores.vue?vue&type=script&lang=js&"
export * from "./Colaboradores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports